import { fromJS, List, Map } from 'immutable';

import * as actions from '../actions/eventActivities';

const defaultState = fromJS({
  activities: [],
  activitiesOnlyValues: [],
  allActivitiesWithoutDuplicates: [],
  backloggedActivityValues: [],
});

export default function statuses(state = defaultState, action) {
  switch (action.type) {
    case actions.FETCHING_ACTIVITIES_SUCCESS:
      return state.merge({
        activities: fromJS(action.response.data),
        allActivitiesWithoutDuplicates: mergeUniqueByValue(action.response.data.all),
        backloggedActivityValues: action.response.data.backloggedActivities.map(activity => activity.value),
      });

    case actions.FETCHING_ACTIVITIES_ONLY_VALUES_SUCCESS:
      return state.set('activitiesOnlyValues', fromJS(action.response.data));

    default:
      return state;
  }
}

const mergeUniqueByValue = data => {
  const allActivities = List([...data.target, ...data.buyer, ...data.exec, ...data.lp]);
  const seen = new Set();

  return List(
    allActivities.reduce((accumulator, { name, value }) => {
      if (!value || seen.has(value)) return accumulator;

      seen.add(value);

      accumulator.push(
        Map({
          name,
          value,
        }),
      );

      return accumulator;
    }, []),
  );
};
